/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Multica_Th8Inputs */

const en_mk_cmp_multica_th8 = /** @type {(inputs: Mk_Cmp_Multica_Th8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The heart of the product: Claude Code, Codex, Cursor, Copilot and 22 more.`)
};

const id_mk_cmp_multica_th8 = /** @type {(inputs: Mk_Cmp_Multica_Th8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inti produknya: Claude Code, Codex, Cursor, Copilot, dan 22 lainnya.`)
};

/**
* | output |
* | --- |
* | "The heart of the product: Claude Code, Codex, Cursor, Copilot and 22 more." |
*
* @param {Mk_Cmp_Multica_Th8Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_multica_th8 = /** @type {((inputs?: Mk_Cmp_Multica_Th8Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Multica_Th8Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_multica_th8(inputs)
	return en_mk_cmp_multica_th8(inputs)
});